module.exports = __webpack_public_path__ + "static/media/timer.b16c5212.png";